<template>
<div class="newPage">
<h1>This is a new page</h1>
</div>
</template>

<script>


export default {
    name: 'NewPage'
}
</script>